import Text from 'components/Text/Text';
import React, { useContext, useEffect, useRef } from 'react';
import { IGetSubCategoriesShort } from 'types';
import { useTranslation } from 'react-i18next';
import { DishesContext, IDishesContext } from '../../../dishesState/dishesContext';
import { Select } from 'antd';
import { useFetchData } from 'hooks/useFetchData';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import { getSubCategoriesShortInfo } from 'backend/subcategories';
import style from './SubCategorySelect.module.scss';

const { Option } = Select;

const SubCategorySelect: React.FC = () => {
	const { setIDSubCategory, IDSelectedSubCategory, IDSelectedCategory } = useContext<IDishesContext>(DishesContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetSubCategoriesShort, string[]>(
		IDSelectedCategory ? getSubCategoriesShortInfo : null,
		IDSelectedCategory ? [IDSelectedCategory] : [],
	);
	const { t } = useTranslation('listing');

	useEffect(() => {
		refetch();
	}, [IDSelectedCategory]);

	const value = IDSelectedCategory && !loading ? IDSelectedSubCategory : undefined;

	return (
		<div className={style.container} data-test="SubCategorySelect">
			<Text translationNameSpace="listing" translationKey="subcategoryLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDSubCategory}
				value={value}
				loading={loading}
				disabled={!IDSelectedCategory}
				allowClear={true}
				removeIcon={false}
				listItemHeight={response?.data.subCategories.length}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				showSearch={true}
				filterOption={(inputValue, option) =>
					option?.children ? String(option.children).toLowerCase().includes(inputValue.toLowerCase()) : false
				}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				<>
					<Option className={style.disabledItem} value="empty" disabled={true}>
						<Text
							translationNameSpace="listing"
							translationKey="selectAnyItemPlaceholder"
							asFragment={true}
						/>
					</Option>
					{response?.data.subCategories.map((el) => (
						<Option className={style.listItem} value={el.id} key={el.id}>
							{el.name}
						</Option>
					))}
				</>
			</Select>
		</div>
	);
};

export default SubCategorySelect;
